import { Inject, ModelEvents } from "@denishussar/html5-game-engine";
import { GameModel, GenObstacleEnum } from "../../Models/GameModel";
import { AbstractGenerator, IGenParams } from "../../Utils/AbstractGenerator/AbstractGenerator";
import { LowEntity } from "./Low";
import { Entity } from "../../Utils/AbstractGenerator/Entity";
import { MedEntity } from "./Med";
import { HighEntity } from "./High";
import { GameLogic } from "../GameLogic";
export class InchGenerator extends AbstractGenerator{
    constructor(
        @Inject private model: GameModel,
        @Inject private events: ModelEvents,
    ){
        super(
            {low: 6,med: 4 ,high: 2 },
            {low: 1, med: 1, high: 1},
            ()=>{

                const low = this.model.generator.generated.filter(e=>e.type == GenObstacleEnum.low).length;
                const med = this.model.generator.generated.filter(e=>e.type == GenObstacleEnum.med).length;
                const high = this.model.generator.generated.filter(e=>e.type == GenObstacleEnum.high).length;
                return <IGenParams>{low, med, high}},
            0.2,
            0.2
            );
        
        this.addNewEntity("low", new LowEntity(this.model, this.events));
        this.addNewEntity("med", new MedEntity(this.model,this, this.events));
        this.addNewEntity("high", new HighEntity(this.model, this.events));
        // this.addNewEntity("empty", <Entity>{usefulness: ()=>{return {low: 0, med: 0, high: 0}}, spawn: ()=>{}})
    }
}